module.exports = __webpack_public_path__ + "static/media/co07.32c145b6.png";